var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"health-data-container d-none"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h3',[_vm._v("Health Data")])]),_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Health Data Content")])])])])
}]

export { render, staticRenderFns }